import React, { useContext, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import Slider from 'react-slick';
import toast from 'react-hot-toast';
import { businessContext } from '../../../UseContext/BusinessContext';


const AddMilestonePopup = () => {

  const { 
    showAddMilestonePopup, setShowAddMilestonePopup,
    milestone, setMilestone,
    milestoneImages, setMilestoneImages,
    createMilestone,
  } = useContext(businessContext);

  const fileInputRef = useRef(null);

  // handle click
  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  // handle file change
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    if((milestoneImages.length + files.length) <= 5) {
      setMilestoneImages((prevImages) => [...files, ...prevImages]);
    } else {
      toast.error(`You can only select 5 images`);
    };
  };

  // handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setMilestone((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
  };

  // handle remove file
  const handleRemoveFile = (fileIndex) => {
    setMilestoneImages((prevImages) => prevImages.filter((_, index) => index !== fileIndex));
  };

  const settings = {
    dots: true,           
    infinite: false,
    speed: 500,           
    slidesToShow: 1,        
    slidesToScroll: 1,        
    adaptiveHeight: true,     
  };

  return (
    <>
      <Modal show={showAddMilestonePopup} onHide={() => setShowAddMilestonePopup(false)} keyboard={false} className="create-post" backdrop="static" centered>
        <Modal.Header closeButton>&nbsp;</Modal.Header>
        <Modal.Body>
          <h4 className='text-center mb-4'>Add Milestone</h4>

          {/* Images */}
          <>
            {
              milestoneImages && milestoneImages.length > 0
              ?
              <div className='mb-3'>
                {/* Add */}
                <>
                  {
                    milestoneImages.length < 5
                    &&
                    <div className='p-1 bg-secondary-subtle rounded-circle d-inline-block mb-2 pt-0' onClick={handleDivClick}>
                      <img src="/images/business/icons/add-circle.svg" style={{ height: '20px' }} alt="add" />

                      <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} multiple />
                    </div>
                  }
                </>

                <Slider className="milestone-images-slider" {...settings}>
                  {
                    milestoneImages && milestoneImages.length > 0
                    &&
                    milestoneImages.map((image, index) => (
                      <div className="border position-relative rounded-3" style={{ maxHeight: '300px' }} key={index}>
                        <img src={URL.createObjectURL(image)} className="rounded-3 object-fit-contain" style={{ height: '300px', width: '100%' }} alt={`Product ${index}`} />

                        <div className='position-absolute top-0 end-0 mt-3 me-3 p-1 rounded-3 shadow-sm' style={{ backgroundColor: '#4b4b4b96' }} onClick={() => handleRemoveFile(index)}>
                          <img src="/images/icons/delete-white.svg" style={{ height: '20px' }} alt="delete" />
                        </div>
                      </div>
                    ))
                  }
                </Slider>
              </div>
              :
              <div className='d-flex flex-column align-items-center w-75 mx-auto rounded-3 py-4 mb-5 cursor-pointer' style={{ border: '1px dashed gray' }} onClick={handleDivClick}>
                <img src={`/images/business/icons/upload-photo-blue.svg`} style={{ height: '80px' }} alt="upload-blue" />

                <small className='text-primary'>Upload</small>
                <small className='text-secondary'>or</small>
                <small>Drop your file here</small>

                <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} multiple />
              </div>
            }
          </>

          {/* Title */}
          <small className='text-secondary'>Title</small>
          <input type="text" className='form-control border-0 border-bottom shadow-none mb-4' name='title' value={milestone.title} onChange={handleInputChange} placeholder='Title...' />

          {/* Date */}
          <small className='text-secondary'>Date</small>
          <input type="date" className='form-control border-0 border-bottom shadow-none mb-4' name='date' value={milestone.date} onChange={handleInputChange} />

          {/* Description */}
          <small className='text-secondary'>Description</small>
          <textarea class="form-control border-0 border-bottom shadow-none mb-4" name='description' value={milestone.description} onChange={handleInputChange} placeholder='Description...'></textarea>

          {/* Add */}
          <div className='text-center'>
            <button type="button" className='btn btn-primary w-50 rounded-pill' onClick={createMilestone}
              disabled={milestoneImages.length === 0 || milestone.title === '' || milestone.date === '' || milestone.description === ''}
            >Add</button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AddMilestonePopup;